import "@mapka/maplibre-gl-sdk/styles.css";
import "@mantine/core/styles.css";
import "@mantine/code-highlight/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/carousel/styles.css";
import "@fontsource-variable/geist-mono/index.css";
import "@fontsource-variable/geist/index.css";
import "./themeOverwrite.css";
import "./theme/button.css";
import "./theme/input.css";
import "./theme/tabs.css";
import "./theme/anchor.css";
import "./theme/accordion.css";
import "./theme/alert.css";
import "./theme/notification.css";
import "./theme/avatar.css";
import "./theme/actionIcon.css";
import "./theme/slider.css";
import "./theme/typography.css";
import "./main.css";

import "dayjs/locale/de";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/fi";
import "dayjs/locale/pl";
import "dayjs/locale/bg";
import "dayjs/locale/cs";
import "dayjs/locale/da";
import "dayjs/locale/es";
import "dayjs/locale/ru";
import "dayjs/locale/et";
import "dayjs/locale/pt";
import "dayjs/locale/ro";
import "dayjs/locale/sk";
import "dayjs/locale/tr";
import "dayjs/locale/vi";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { App } from "./App.js";
import { Provider } from "react-redux";
import { QueryProvider } from "./components/QueryProvider.js";
import { LoggerProvider } from "./components/LoggerProvider.js";
import { theme } from "./theme";
import { Notifications } from "@mantine/notifications";
import { IntlProvider } from "./components/IntlProvider.js";
import { localStorageColorSchemeManager } from "@project/common";
import { store } from "./store.js";
import { createHighlighterCore } from "shiki/core";
import { createJavaScriptRegexEngine } from "shiki/engine/javascript";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { CodeHighlightAdapterProvider, createShikiAdapter } from "@mantine/code-highlight";

ModuleRegistry.registerModules([
  AllCommunityModule,
]);

async function loadShiki() {
  return await createHighlighterCore({
    langs: [
      import("@shikijs/langs/tsx"),
      import("@shikijs/langs/typescript"),
      import("@shikijs/langs/bash"),
      import("@shikijs/langs/html"),
    ],
    themes: [],
    engine: createJavaScriptRegexEngine(),
  });
}
const shikiAdapter = createShikiAdapter(loadShiki);
const colorSchemeManager = localStorageColorSchemeManager();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <CodeHighlightAdapterProvider adapter={shikiAdapter}>
        <Provider store={store}>
          <IntlProvider>
            <MantineProvider theme={theme} colorSchemeManager={colorSchemeManager}>
              <Notifications />
              <QueryProvider>
                <LoggerProvider>
                  <App />
                </LoggerProvider>
              </QueryProvider>
            </MantineProvider>
          </IntlProvider>
        </Provider>
      </CodeHighlightAdapterProvider>
    </StrictMode>,
  );
}
else {
  throw new Error("root element missing");
}
